import React from 'react';
import { Workflow, Database, Mail, ClipboardCheck, Briefcase, Users, FileText } from 'lucide-react';

const services = [
  {
    icon: <Workflow className="w-6 h-6 text-brand-primary" />,
    title: "Agentic Workflows",
    description: "Autonomous multi-agent systems that handle complex decision-making tasks without human intervention."
  },
  {
    icon: <Database className="w-6 h-6 text-brand-primary" />,
    title: "Intelligent Data Pipelines",
    description: "Transform unstructured data into actionable insights using vector databases and RAG architectures."
  },
  {
    icon: <Mail className="w-6 h-6 text-brand-primary" />,
    title: "Lead Generation",
    description: "AI Cold Email Systems, Application Systems, and Content Systems designed to fill your funnel autonomously."
  },
  {
    icon: <ClipboardCheck className="w-6 h-6 text-brand-primary" />,
    title: "Project Management",
    description: "AI Automated Fulfillment, Onboarding Systems, and PM Systems that keep projects moving 24/7."
  },
  {
    icon: <Briefcase className="w-6 h-6 text-brand-primary" />,
    title: "Sales Administration",
    description: "Customized CRMs, AI Asset Generators, and Nurture Systems to streamline your revenue operations."
  },
  {
    icon: <Users className="w-6 h-6 text-brand-primary" />,
    title: "Hiring Systems",
    description: "Intelligent Intake, AI Scoring, and Trial Systems to identify and secure top talent faster."
  },
  {
    icon: <FileText className="w-6 h-6 text-brand-primary" />,
    title: "Document Intelligence",
    description: "Intelligent extraction, Sovereign AI, Smart Tagging & Routing, Vision LLM, and Structured Schema Extraction."
  }
];

export default function Services() {
  return (
    <section id="services" className="py-20 px-6 lg:px-[7.69%] border-b border-border-medium bg-bg-primary">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-12">
          <span className="section-tag">/Expertise</span>
          <h3 className="display-large">Engineering The Autonomous Enterprise</h3>
          <p className="body-medium mt-3 max-w-2xl">
            Specialized capabilities across the agentic stack — from data ingest to autonomous decisioning.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, idx) => (
            <div key={idx} className="terminal-card p-6 flex flex-col gap-4">
              <div className="p-2 bg-brand-hover w-fit border border-brand-primary/30">
                {service.icon}
              </div>
              <h4 className="heading-3">{service.title}</h4>
              <p className="body-medium">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
